module.exports = __webpack_public_path__ + "img/pre_new_en.6b487d32.png";